import styled from '../theme/styled-components';
import { LightIcon } from './Icon';

export const Footer = styled.div`
  background: ${props => props.theme.colors.typography.dark.base};
  color: ${props => props.theme.colors.typography.light.base};
  padding-right: ${props => props.theme.spacings.medium};
  padding-left: ${props => props.theme.spacings.medium};
  border-top: 1px solid ${props => props.theme.colors.border.light.base};
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  ${media => media.theme.media.greaterThan('medium')`
    padding-top: ${props => props.theme.spacings.tiny};
    padding-bottom: ${props => props.theme.spacings.base};
  `}

  ${media => media.theme.media.lessThan('downMedium')`
    flex-direction: column;
  `};
`;

export const FooterLinks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media => media.theme.media.lessThan('downMedium')`
  padding-top: ${props => props.theme.spacings.tiny}; 
  padding-bottom: ${props => props.theme.spacings.base};
`}
`;

export const FooterLink = styled.a`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.typography.light.base};

  &:not(:last-child) {
    padding-right: ${props => props.theme.spacings.base};
  }

  // TODO: Maybe create prop on Icon component instead?
  > ${LightIcon} {
    padding-right: calc(${props => props.theme.spacings.tiny} / 2);
  }

  &:hover,
  &:focus {
    color: ${props => props.theme.colors.typography.light.hover};
    text-decoration: none;
    outline: none;
  }
`;

export const FooterTitle = styled.div`
  text-align: center;
  font-weight: ${props => props.theme.typography.brandTagline.fontWeight}
  font-size: ${props => props.theme.typography.body.fontSize};

  ${media => media.theme.media.lessThan('downMedium')`
    padding-bottom: ${props => props.theme.spacings.tiny};
  `}

`;
